import { createContext, useContext } from 'react';
import useProgress from '../hooks/useProgress';

const ProgressContext = createContext(null);

export function ProgressProvider({ children }) {
  const progress = useProgress();
  return (
    <ProgressContext.Provider value={progress}>
      {children}
    </ProgressContext.Provider>
  );
}

export function useProgressContext() {
  const ctx = useContext(ProgressContext);
  // FIX: throw a clear error if used outside ProgressProvider
  // instead of silently returning null and crashing somewhere deeper
  if (!ctx) {
    throw new Error('useProgressContext must be used inside <ProgressProvider>. Wrap your app in ProgressProvider.');
  }
  return ctx;
}